/**
 * Store module — Parameters
 *
 * Phase 4 — Les 27 getters identiques sont maintenant générés depuis une table
 * de configuration. L'API publique (noms des getters) est inchangée, donc
 * aucun composant n'a besoin d'être modifié.
 *
 * Pour ajouter un nouveau paramètre : ajouter une entrée dans PARAMETER_MAP.
 */

// ── Helpers ──────────────────────────────────────────────────────────

const safeFind = (parameters, no, type) => {
  if (!parameters || !Array.isArray(parameters)) return null
  return parameters.find(item => item.no === no && item.type === type)
}

/**
 * Retourne `find.valeur` ou null.
 * Accepte un `transform` optionnel pour post-traiter la valeur.
 */
const getValue = (state, no, type, transform) => {
  const found = safeFind(state.parameters, no, type)
  if (!found) return null
  return transform ? transform(found.valeur) : found.valeur
}

// ── Configuration des paramètres ─────────────────────────────────────
// Chaque entrée : [getterName, no, type, transform?]

const PARAMETER_MAP = [
  // 01Cell — Paramètres généraux
  ['getFournisseurPaiement', 23, 'parameters'],
  ['getLongueurCodeFacturation', 25, 'parameters'],
  ['getContratType2Max', 11, 'parameters'],
  ['getPickupDeliveryType1', 21, 'parameters'],
  ['getPickupDeliveryType2', 22, 'parameters'],
  ['getPickupDeliveryType3', 26, 'parameters'],
  ['getModePaiement', 20, 'parameters'],
  ['getJourMaxExEmployee', 24, 'parameters'],
  ['getWebSite', 9, 'parameters'],
  ['getAdresseCourrielFournisseur', 12, 'parameters'],
  ['getFournisseur', 10, 'parameters'],
  ['getCodeFacturation', 15, 'parameters'],
  ['getLanguage', 2, 'parameters'],
  ['getSimCard', 32, 'parameters'],
  ['getFraisReActivation', 41, 'parameters'],
  ['getInstitutionName', 45, 'parameters'],
  ['getGestionGroup', 46, 'parameters'],
  ['getCommanderPour', 48, 'parameters'],
  ['getNomClient', 33, 'parameters'],
  ['getMiragrationBtn', 49, 'parameters'],
  ['getDescriptifContrat', 50, 'parameters'],
  ['getNombreCarteCreditPermise', 51, 'parameters'],
  ['getCarteCreditAutoAManuel', 52, 'parameters'],

  // Paramètres avec transform
  ['getStepHeure', 17, 'parameters', v => parseInt(v)],
  ['getAllowHours', 18, 'parameters', v => v.split(',').map(n => parseInt(n, 10))],
  ['getAllowDays', 19, 'parameters', v => v.split(',').map(n => parseInt(n, 10))],

  // Toggles
  ['ifShowOrderLineCreditCard', 1, 'toggles'],
  ['ifShowOrderLineUbr', 2, 'toggles'],
  ['ifShowOrderDeviceUbr', 3, 'toggles'],
]

// ── Génération des getters ───────────────────────────────────────────

const generatedGetters = {}
PARAMETER_MAP.forEach(([name, no, type, transform]) => {
  generatedGetters[name] = (state) => getValue(state, no, type, transform)
})

// ── Module ───────────────────────────────────────────────────────────

const parameters = {
  strict: true,
  namespaced: true,
  state: {
    parameters: [],
  },
  getters: {
    /**
     * Getter générique — pour accéder à un paramètre par no/type sans créer
     * un getter dédié. Utile pour les cas ponctuels.
     *   this.$store.getters['parameters/getParameter']({ no: 23, type: 'parameters' })
     */
    getParameter: (state) => ({ no, type, transform }) => {
      return getValue(state, no, type, transform)
    },

    // Getters nommés (rétrocompatibles — générés depuis PARAMETER_MAP)
    ...generatedGetters,
  },
  mutations: {
    setParameters (state, payload) {
      state.parameters = payload
    },
  },
  actions: {},
}

export default parameters
